import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateCodeModal, EditCodeModal, CodeListFilters } from "@modules/codes/components";

import {  useCodeList } from "./controller";
import { useCodeListColumns } from "./columns";

export const CodeList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createCodeModalRef,
    editCodeModalRef,
    discounts,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } =  useCodeList();

  const columns = useCodeListColumns(refetch, translate, editCodeModalRef, discounts);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <CodeListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="codes.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createCodeModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateCodeModal
        modalRef={createCodeModalRef}
        onComplete={refetch}
      />

      <EditCodeModal
        modalRef={editCodeModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
